import * as yup from 'yup';

const billingValidationSchema = (t) =>
  yup.object({
    companyName: yup
      .string()
      .max(50, t('billingForm.validation.companyName.maxLength'))
      .required(t('billingForm.validation.companyName.required')),
    billingVatNumber: yup
      .string()
      .matches(/^[0-9]{8}[-][0-9][-][0-9]{2}$/, t('billingForm.validation.vatNumber.format'))
      .required(t('billingForm.validation.vatNumber.required')),
    billingAccountNumber: yup
      .string()
      .matches(
        /^[0-9]{8}[-][0-9]{8}[-][0-9]{8}$|^[0-9]{8}[-][0-9]{8}$|^[0-9]{16}$|^[0-9]{24}$/,
        t('billingForm.validation.accountNumber.format')
      )
      .max(26, t('billingForm.validation.accountNumber.maxLength'))
      .required(t('billingForm.validation.accountNumber.required')),
    billingCountry: yup
      .string()
      .min(1, t('billingForm.validation.country.minLength'))
      .max(40, t('billingForm.validation.country.maxLength'))
      .required(t('billingForm.validation.country.required')),
    billingCity: yup
      .string()
      .max(40, t('billingForm.validation.city.maxLength'))
      .required(t('billingForm.validation.city.required')),
    billingZipCode: yup
      .number()
      .typeError(t('billingForm.validation.zipCode.typeError'))
      .min(999, t('billingForm.validation.zipCode.min'))
      .max(9999, t('billingForm.validation.zipCode.max'))
      .required(t('billingForm.validation.zipCode.required')),
    billingStreetAndNumber: yup
      .string()
      .min(1, t('billingForm.validation.streetAndNumber.minLength'))
      .max(40, t('billingForm.validation.streetAndNumber.maxLength'))
      .required(t('billingForm.validation.streetAndNumber.required'))
  });

export default billingValidationSchema;
